import {Injectable} from '@angular/core';
import {BasePermissionService} from './base-permission.service';
import {AuthApiService} from '@spa/api';
import {AmsPermissionRulesTrait} from 'appEntries/panel/traits';
import {Helper} from 'appShared/classes';

@Injectable({
    providedIn: 'root'
})
export class AmsPermissionService extends BasePermissionService {

    constructor(protected readonly authApiService: AuthApiService) {
        super(authApiService);
    }

    private hasUnionPermissionByPermissionList(permissions: string[]): boolean {
        return Helper.getUnionStrategyPermissionsCheck(
            permissions,
            this.authUserPermissions
        );
    }

    public hasCompaniesView(isFetchAllRequest: boolean, isEmail = false): boolean {
        if (isFetchAllRequest) {
            return Helper.getUnionStrategyPermissionsCheck(
                AmsPermissionRulesTrait.getAmsCompanyViewPermissionRule().permissions,
                this.authUserPermissions
            );
        }

        if (isEmail) {
            return Helper.getUnionStrategyPermissionsCheck(
                AmsPermissionRulesTrait.getAmsEmailCompanyViewPermissionRule().permissions,
                this.authUserPermissions
            );
        }

        return Helper.getUnionStrategyPermissionsCheck(
            AmsPermissionRulesTrait.getAmsMessagingCompanyViewPermissionRule().permissions,
            this.authUserPermissions
        );
    }

    public hasEditEmailTemplate(): boolean {
        return this.hasUnionPermissionByPermissionList(AmsPermissionRulesTrait.getAmsEmailTemplateEditPermissionRule().permissions);
    }

    public hasCreateEmailTemplate(): boolean {
        return this.hasUnionPermissionByPermissionList(AmsPermissionRulesTrait.getAmsEmailTemplateCreatePermissionRule().permissions);
    }

    public hasViewEmailTemplate(): boolean {
        return this.hasUnionPermissionByPermissionList(AmsPermissionRulesTrait.getAmsEmailTemplateViewPermissionRule().permissions);
    }

    public hasApproveEmailTemplate(): boolean {
        return this.hasUnionPermissionByPermissionList(AmsPermissionRulesTrait.getAmsEmailTemplateApprovePermissionRule().permissions);
    }

    public hasCustomerProductsView(): boolean {
        return this.hasCreateEmailTemplate();
    }

    public hasEditMessageTemplate(): boolean {
        return this.hasUnionPermissionByPermissionList(AmsPermissionRulesTrait.getAmsMessageTemplateEditPermissionRule().permissions);
    }

    public hasCreateMessageTemplate(): boolean {
        return this.hasUnionPermissionByPermissionList(AmsPermissionRulesTrait.getAmsMessageTemplateCreatePermissionRule().permissions);
    }

    public hasViewMessageTemplate(): boolean {
        return this.hasUnionPermissionByPermissionList(AmsPermissionRulesTrait.getAmsMessageTemplateViewPermissionRule().permissions);
    }

    public hasApproveMessageTemplate(): boolean {
        return this.hasUnionPermissionByPermissionList(AmsPermissionRulesTrait.getAmsMessageTemplateApprovePermissionRule().permissions);
    }

    public hasAddMessageRequestPermission(): boolean {
        return this.hasUnionPermissionByPermissionList(AmsPermissionRulesTrait.getMessageRequestCreatePermissionRule().permissions);
    }

    public hasEditMessageRequestPermission(): boolean {
        return this.hasUnionPermissionByPermissionList(AmsPermissionRulesTrait.getMessageRequestEditPermissionRule().permissions);
    }

    public hasEditOrViewMessageRequestPermission(): boolean {
        return this.hasUnionPermissionByPermissionList(AmsPermissionRulesTrait.getMessageRequestEditOrViewPermissionRule().permissions);
    }

    hasSendMessageWithTemplatePermission(): boolean {
        return this.hasUnionPermissionByPermissionList(
            AmsPermissionRulesTrait.getMessageRequestSendWithTemplatePermissionRule().permissions
        );
    }

    hasCreateMessageWithTemplatePermission(): boolean {
        return this.hasUnionPermissionByPermissionList(
            AmsPermissionRulesTrait.getMessageRequestCreateWithTemplatePermissionRule().permissions
        );
    }

    hasEditMessageWithTemplatePermission(): boolean {
        return this.hasUnionPermissionByPermissionList(
            AmsPermissionRulesTrait.getMessageRequestEditWithTemplatePermissionRule().permissions
        );
    }

    hasSendManualMessagePermission(): boolean {
        return this.hasUnionPermissionByPermissionList(
            AmsPermissionRulesTrait.getMessageRequestSendManualPermissionRule().permissions
        );
    }

    hasCreateManualMessagePermission(): boolean {
        return this.hasUnionPermissionByPermissionList(
            AmsPermissionRulesTrait.getMessageRequestCreateManualPermissionRule().permissions
        );
    }

    hasEditManualMessagePermission(): boolean {
        return this.hasUnionPermissionByPermissionList(
            AmsPermissionRulesTrait.getMessageRequestEditManualPermissionRule().permissions
        );
    }
}
